import { RubricCriteriaCanvas } from '@/components/admin/evaluation-rubrics/rubric-criteria-canvas'
import { type RubricCriterion } from '@/hooks/use-evaluation-rubrics-admin'

type RubricFocusAreaCanvasProps = {
  criteria: RubricCriterion[]
  skillOptions?: string[]
  focusCriterionKey?: string
  onSave: (criteria: RubricCriterion[]) => void
  onClose: () => void
}

export function RubricFocusAreaCanvas(props: RubricFocusAreaCanvasProps) {
  return <RubricCriteriaCanvas {...props} kinds={['competency']} />
}
